import { PropTypes } from "prop-types"
import classNames from "classnames"

import Modal from "../Modal"

export const ModalWithHeader = props => {
  const { children, cssClassName, contentLabel, onClose, hideHeader, ...rest } = props
  return (
    <Modal
      cssClassName={classNames("oj-modal-with-header", cssClassName)}
      contentLabel={contentLabel}
      onClose={onClose}
      {...rest}
    >
      {!hideHeader && <Modal.Header onClose={onClose}>{contentLabel}</Modal.Header>}
      <Modal.Content>{children}</Modal.Content>
    </Modal>
  )
}

ModalWithHeader.propTypes = {
  aria: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node,
  contentLabel: PropTypes.string,
  cssClassName: PropTypes.string,
  hideHeader: PropTypes.bool,
  onClose: PropTypes.func
}

export default ModalWithHeader
